import React from 'react';
import { trackInitiateCheckout } from '../lib/metaPixel';
interface CTAButtonProps {
  text: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const CHECKOUT_URL = 'https://bypaolarojas.com/products/glow-up-femenino-en-30-dias?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web';
export function CTAButton({
  text,
  size = 'md',
  className = ''
}: CTAButtonProps) {
  const sizes = {
    sm: 'px-8 py-3 text-sm',
    md: 'px-10 py-4 text-base',
    lg: 'px-12 py-5 text-lg'
  };
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className={`inline-block bg-primary text-primary-foreground ${sizes[size]} rounded-full font-sans tracking-wide hover:bg-primary/90 transition-all duration-300 shadow-soft hover:shadow-lg hover:-translate-y-0.5 text-center ${className}`} data-id="element-56">
      {text}
    </a>;
}